import arrowIcon from "@assets/images/Frame-9.svg";
import downloadIcon from "@assets/icons/download.svg";

type ButtonProps = {
  title: string;
  onClick?: () => void;
  className?: string;
};

export const HeroButton = ({ onClick, title, className }: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`px-3 md:px-4 py-2.5 md:py-[17.5px] text-xs md:text-lg rounded-full flex items-center gap-2.5  bg-[#080c2d] text-white hover:bg-[#0f1554] flex-shrink-0 transition-colors duration-300 group/btn font-semibold ${className}`}
    >
      {title}
      <img
        src={arrowIcon}
        alt="arrow icon"
        className="transition-all duration-300 size-8 md:size-10 group-hover/btn:translate-x-0.5"
      />
    </button>
  );
};

export const RequirementButton = ({
  onClick,
  title,
  className,
}: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`px-3 md:px-4 py-2.5 md:py-[17.5px] text-xs md:text-lg rounded-full flex items-center gap-2.5 bg-white text-[#0d6e6e] hover:bg-white/90 flex-shrink-0 transition-colors duration-300 group/btn font-semibold ${className}`}
    >
      {title}
      <img
        src={downloadIcon}
        alt="arrow icon"
        className="transition-all duration-300 size-8 md:size-10 group-hover/btn:translate-x-0.5"
      />
    </button>
  );
};
